import React, { type ReactNode } from 'react';
import { reportHydrationEnd } from '@atlassian/jira-ssr-controller/src/use-is-page-hydrating.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { RenderAfterHydrationCompletion } from './RenderAfterHydrationCompletion.tsx';

const Setter = () => {
	reportHydrationEnd();
	return null;
};

export const HydrationFinishedSetter = (): ReactNode => {
	if (fg('jfp-magma-fix-hydration-completion')) {
		return null;
	}

	return (
		<RenderAfterHydrationCompletion>
			<Setter />
		</RenderAfterHydrationCompletion>
	);
};
